import axios from 'axios'
import { getClientType } from './clientConfig'

const ORDERS_API_URL = 'https://kbkuyis6cd.execute-api.eu-central-1.amazonaws.com'

const getOrdersApiUrl = () => {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get('ordersApi') || localStorage.getItem('ordersApiUrl') || ORDERS_API_URL
}

const nextOrderNumber = () => {
  let counter = parseInt(localStorage.getItem('orderCounter') || '0', 10)
  counter = (counter % 999) + 1
  localStorage.setItem('orderCounter', counter.toString())
  return counter.toString()
}

export const sendOrder = async (cart) => {
  const storeId = getClientType()
  const apiUrl = getOrdersApiUrl()

  const items = cart.map((cartItem, index) => ({
    id: index,
    name: cartItem.title,
    quantity: cartItem.qty,
    additions: [],
  }))

  const order = {
    storeId,
    items,
    pickupOrderNumber: nextOrderNumber(),
  }

  try {
    const response = await axios.post(`${apiUrl}/orders`, order)
    console.log('Order sent to KDS:', response.data)
    return response.data
  } catch (error) {
    console.error('Failed to send order to KDS:', error)
    return null
  }
}
